var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var getPositionDetails = function getPositionDetails(position) {
  return {
    isPositive: position === 'right' || position === 'bottom',
    isNegative: position === 'left' || position === 'top',
    isVertical: position === 'left' || position === 'right',
    isHorizontal: position === 'top' || position === 'bottom'
  };
};
var getVisibility = function getVisibility(isVisible) {
  return isVisible ? 'unset' : 'hidden';
};
var getInitialTranslateValues = function getInitialTranslateValues(target, tooltip, position) {
  var _getPositionDetails = getPositionDetails(position),
      isPositive = _getPositionDetails.isPositive,
      isHorizontal = _getPositionDetails.isHorizontal;

  var el = isPositive ? target : tooltip;
  var span = isHorizontal ? el.height : el.width;
  var translateX, translateY;

  if (isHorizontal) {
    var centered = tooltip.width / 2 - target.width / 2;
    translateX = -centered;
    translateY = isPositive ? span : -span;
  } else {
    var _centered = target.height / 2 - tooltip.height / 2;

    translateX = isPositive ? span : -span;
    translateY = _centered;
  }

  return {
    translateX: translateX,
    translateY: translateY
  };
};
var getInitialTransform = function getInitialTransform(target, tooltip, position, spacing) {
  var _getInitialTranslateV = getInitialTranslateValues(target, tooltip, position),
      translateX = _getInitialTranslateV.translateX,
      translateY = _getInitialTranslateV.translateY;

  return buildTranslatePropertyValue(translateX, translateY, position, spacing);
};
var getAdjustedTransform = function getAdjustedTransform(target, tooltip, position, spacing, containerWidth, containerHeight) {
  var _getPositionDetails2 = getPositionDetails(position),
      isHorizontal = _getPositionDetails2.isHorizontal;

  var _getInitialTranslateV2 = getInitialTranslateValues(target, tooltip, position),
      translateX = _getInitialTranslateV2.translateX,
      translateY = _getInitialTranslateV2.translateY;

  var offset = 0;

  if (isHorizontal) {
    if (tooltip.left < 0) {
      offset = tooltip.left;
    }

    if (tooltip.right > containerWidth) {
      offset = tooltip.right - containerWidth;
    }

    translateX = translateX - offset;
  } else {
    if (tooltip.top < 0) {
      offset = tooltip.top;
    }

    if (tooltip.bottom > containerHeight) {
      offset = tooltip.bottom - containerHeight;
    }

    translateY = translateY - offset;
  }

  return buildTranslatePropertyValue(translateX, translateY, position, spacing);
};
var buildTranslatePropertyValue = function buildTranslatePropertyValue(translateX, translateY, position, spacing) {
  var _getPositionDetails3 = getPositionDetails(position),
      isHorizontal = _getPositionDetails3.isHorizontal;

  var operatorX = translateX > 0 ? '+' : '-';
  var operatorY = translateY > 0 ? '+' : '-';
  var x, y;

  if (isHorizontal) {
    x = "calc(".concat(translateX, "px)");
    y = "calc(".concat(translateY, "px ").concat(operatorY, " ").concat(spacing, ")");
  } else {
    x = "calc(".concat(translateX, "px ").concat(operatorX, " ").concat(spacing, ")");
    y = "calc(".concat(translateY, "px)");
  }

  return "translate(".concat(x, ",").concat(y);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".main_main__2K5md{position:relative}.main_target__27gM3,.main_tooltip__3Azez{top:0;left:0}.main_tooltip__3Azez{width:100%;position:absolute;align-items:center;justify-content:center;z-index:1000000}";
var css = {"main":"main_main__2K5md","target":"main_target__27gM3","tooltip":"main_tooltip__3Azez"};
styleInject(css_248z);

var main = css.main,
    target = css.target,
    tooltip = css.tooltip,
    content = css.content;

var Tooltip = function Tooltip(_ref) {
  _ref.message;
      var children = _ref.children,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 0 : _ref$spacing;
  var initialState = {
    isVisible: false,
    transform: 'unset'
  };

  var _useState = React.useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var targetRef = React.useRef();
  var tooltipRef = React.useRef();

  var show = function show() {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        isVisible: true,
        transform: getAdjustedTransform(targetRef.current.getBoundingClientRect(), tooltipRef.current.getBoundingClientRect(), position, spacing, window.innerWidth, window.innerHeight)
      });
    });
  };

  var hide = function hide() {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        isVisible: false,
        transform: getInitialTransform(targetRef.current.getBoundingClientRect(), tooltipRef.current.getBoundingClientRect(), position, spacing)
      });
    });
  };

  var handleMouseLeave = function handleMouseLeave() {
    hide();
  };

  var handleMouseEnter = function handleMouseEnter() {
    show();
  };

  var handleClick = function handleClick() {
    show();
  };

  React.useEffect(function () {
    window.addEventListener('scroll', hide);
    window.addEventListener('click', hide, true);
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        transform: getInitialTransform(targetRef.current.getBoundingClientRect(), tooltipRef.current.getBoundingClientRect(), position, spacing)
      });
    });
    return function () {
      window.removeEventListener('scroll', hide);
      window.removeEventListener('click', hide);
    };
  }, []);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    ref: targetRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    className: main
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: target
  }, children[0]), /*#__PURE__*/React__default['default'].createElement("div", {
    className: tooltip,
    style: {
      overflowX: getVisibility(state.isVisible),
      visibility: getVisibility(state.isVisible),
      transform: state.transform
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: content
  }, /*#__PURE__*/React.cloneElement(children[1], {
    ref: tooltipRef
  }))));
};

module.exports = Tooltip;
